import axiosInstance from '@/shared/api/axios';
import type { PricingConfig } from '@/shared/types/api/pricing';

export const apiPricingConfigGet = async (): Promise<PricingConfig> => {
  const { data } = await axiosInstance.get<PricingConfig>('/pricing/config');
  return data;
};
